/* 页面初始化宽高 */
import store from '@/store'

function init () {
  store.dispatch('app/setContainer', { width: window.innerWidth, height: window.innerHeight })
}

function setPageScaleCover () {
  const designWidth = 1920
  const designHeight = 955
  const viewportWidth = window.innerWidth
  const viewportHeight = window.innerHeight

  // 取较大值，让内容填满视口（会裁剪溢出部分）
  const scaleX = viewportWidth / designWidth
  const scaleY = viewportHeight / designHeight
  let scale = 1
  let appHeight = viewportHeight
  let appWidth = viewportWidth
  if (scaleX > scaleY) {
    scale = scaleX
    appHeight = Math.floor(viewportHeight / scale) + 'px'
    appWidth = designWidth + 'px'
  } else {
    scale = scaleY
    appWidth = Math.floor(viewportWidth / scale) + 'px'
    appHeight = designHeight + 'px'
  }
  const app = document.getElementById('app')
  app.style.transformOrigin = 'top left'
  app.style.transform = `scale(${scale})`
  app.style.width = appWidth
  app.style.height = appHeight
}

export default {
  init,
  setPageScaleCover
}
